import script from "./CompaniesStatsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CompaniesStatsSection.vue?vue&type=script&setup=true&lang=js"

import "./CompaniesStatsSection.vue?vue&type=style&index=0&id=6337758c&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6337758c"]])

export default __exports__